/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _DisorderHistoryEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";
import JournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import journalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import DisorderHistoryDeclaredJournalEvent from "core/models/disorder-history-declared-journal-event";
import { EmberChangeset } from "ember-changeset";
let DisorderHistoryEditionFormComponent = (_class = (_DisorderHistoryEditionFormComponent = class DisorderHistoryEditionFormComponent extends JournalEventBasedComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "journalEventProperties", ["occurredAt", "numberOfDepressiveEpisode", "numberOfHypomaniacEpisode", "numberOfManiacEpisode", "numberOfEpisodeCommentary", "numberOfHospitalization", "numberOfTs", "numberOfTsWithThymicEpisode", "numberOfTsCommentary", "presenceOfRapidCycles", "presenceOfRapidCyclesCommentary", "thymicEpisodes", "firstThymicEpisode"]);
    _defineProperty(this, "retrieveJournalEvent", journalEventRetrievalStrategies.sourceJournalEvent);
    /**
     * Store the sub changesets created for the thymic episodes.
     */
    _initializerDefineProperty(this, "thymicEpisodeChangesets", _descriptor, this);
  }
  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.thymicEpisodes = [];
      model.firstThymicEpisode = {};
      model.occurredAt = new Date();
    } else {
      // Extract the first thymic episode
      model.firstThymicEpisode = this.retrieveFirstThymicEpisode(model.thymicEpisodes);
      model.thymicEpisodes = model.thymicEpisodes.filter(episode => episode != model.firstThymicEpisode);
    }
    return model;
  }
  computePayload() {
    const payload = super.computePayload();
    // Execute every sub-changeset to apply changes to our model
    this.thymicEpisodeChangesets.forEach(changeset => changeset.execute());
    // Save the first thymic episode
    if (payload.firstThymicEpisode) {
      payload.thymicEpisodes.push(payload.firstThymicEpisode);
    }
    return payload;
  }
  onThymicEpisodeCreated(changeset) {
    this.thymicEpisodeChangesets.push(changeset);
  }
  onThymicEpisodeDestroyed(changeset) {
    this.thymicEpisodeChangesets = this.thymicEpisodeChangesets.filter(e => e != changeset);
  }
  get isDirty() {
    if (this.changeset.get("isDirty")) {
      return true;
    }
    for (const changeset of this.thymicEpisodeChangesets) {
      if (changeset.get("isDirty")) {
        return true;
      }
    }
    return false;
  }
  retrieveFirstThymicEpisode(thymicEpisodes) {
    return thymicEpisodes.slice().sort((a, b) => {
      return new Date(a.occurredAt).getTime() - new Date(b.occurredAt).getTime();
    })[0];
  }
}, _defineProperty(_DisorderHistoryEditionFormComponent, "fullComponentId", "disorder-history/edition"), _defineProperty(_DisorderHistoryEditionFormComponent, "forcDisplayName", "Historique du trouble avant accompagnement"), _defineProperty(_DisorderHistoryEditionFormComponent, "journalEventClass", DisorderHistoryDeclaredJournalEvent), _DisorderHistoryEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "thymicEpisodeChangesets", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "onThymicEpisodeCreated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onThymicEpisodeCreated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onThymicEpisodeDestroyed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onThymicEpisodeDestroyed"), _class.prototype), _class);
export { DisorderHistoryEditionFormComponent as default };